export default {
  // 商详
  product: {},
  // nproduct: {},
  // 选中的sku
  selectedSku: {},
  // 选中的支付方式
  selectedPayMethod: '',
  // 常见问题里列表
  questionList: [],
  // 服务说明
  serveExplanation: [],
  // 排班数据
  workers: [],
  // 地址-服务人员-日期
  selectedAddress: {},
  selectedWorker: {},
  selectedTime: '',
  // 不能选的时间点
  unworkDays: [],
  // 可预约的时间
  workDays: [],
  // 查询月数
  lookMonths: [],
  // 获取本店其他服务
  otherServiceDatas: [],
  fullDays: [],
  // 评论数据
  comments: [],
  commentCount: 0,
  praiseRate: 0,
  // 商详首页的提示（cms配）
  tip: {},
  // 主要配置
  mainConfig: {},
  storeServices: [],
  //判断是否是成长加商品
  isCzjSpu: false,
  //是否重定向到新的页面
  isRedirect: false
}
